import React from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import { ReceiptLong, Visibility } from '@mui/icons-material';
import { formatCurrency, formatDate } from '../paymentNormalizer';

export default function PaymentRelatedDocumentsSection({ documents = [], onViewDocument }) {
  const list = Array.isArray(documents) ? documents : [];

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
        Documentos relacionados
      </Typography>

      {list.length === 0 ? (
        <Alert severity="info">No hay documentos relacionados.</Alert>
      ) : (
        <Stack spacing={0.75}>
          {list.map((doc) => (
            <Box
              key={doc.id || doc.code}
              sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                p: 1,
                bgcolor: 'background.paper',
              }}
            >
              <Stack direction="row" spacing={1} alignItems="flex-start">
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: 1,
                    bgcolor: 'action.hover',
                    display: 'grid',
                    placeItems: 'center',
                    flexShrink: 0,
                  }}
                >
                  <ReceiptLong fontSize="small" />
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600 }} noWrap>
                    {doc.code || doc.number || `Documento ${doc.id || ''}`}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {[doc.date ? formatDate(doc.date) : null, doc.supplier].filter(Boolean).join(' - ')}
                  </Typography>
                  {(doc.amount || doc.total || doc.balance) && (
                    <Typography variant="caption" color="text.secondary">
                      {[
                        doc.amount ? `Aplicado ${formatCurrency(doc.amount)}` : null,
                        doc.total ? `Total ${formatCurrency(doc.total)}` : null,
                        doc.balance ? `Saldo ${formatCurrency(doc.balance)}` : null,
                      ].filter(Boolean).join(' - ')}
                    </Typography>
                  )}
                </Box>
                {onViewDocument && (
                  <Button
                    size="small"
                    startIcon={<Visibility fontSize="small" />}
                    onClick={() => onViewDocument(doc)}
                    variant="outlined"
                    sx={{ flexShrink: 0, textTransform: 'none', height: 30 }}
                  >
                    Ver
                  </Button>
                )}
              </Stack>
            </Box>
          ))}
        </Stack>
      )}
    </Stack>
  );
}
